import "./LayoutWizardSeasonDialog.scss";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import * as layoutWizardHelper from "@/helpers/layoutWizardHelper";

export default {
  name: "LayoutWizardSeasonDialog",
  components: {},
  data: () => ({
    mainPeacock: "#00636C",
    isRequired: [v => !!v || "Feld bitte ausfüllen"],
    seasonModal: false,
    seasons: []
  }),
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    }
  },
  methods: {
    ...layoutWizardHelper,
    async openSeasons() {
      await this.loadSeasons();
      this.seasonModal = true;
    },
    async createSeason(season) {
      season.principal_id = this.currentPrincipal;
      const headers = getTokenHeader(),
        res = await axios.post(
          `${env.assistent_api_client_url}seasons/`,
          season,
          {
            headers
          }
        );
      return res.status === 200;
    },
    async updateSeason(season) {
      const headers = getTokenHeader(),
        res = await axios.put(
          `${env.assistent_api_client_url}seasons/${season._id}`,
          season,
          { headers }
        );
      return res.status === 200;
    },
    async deleteSeason(season) {
      this.$confirm(
        `Sind Sie sicher, dass Sie <br>
        die Saison <b>${season.title}</b> löschen wollen?`,
        { ...confirmWarningConfig, title: `${season.title} löschen?` }
      ).then(async resp => {
        if (resp) {
          try {
            const headers = getTokenHeader();
            axios.delete(
              `${env.assistent_api_client_url}seasons/${season._id}`,
              {
                headers
              }
            );
            let deleteIndex = this.seasons.indexOf(season);
            this.seasons.splice(deleteIndex, 1);
          } catch (error) {
            this.createError(error);
          }
        }
      });
    },
    updateSeasons() {
      this.seasons.forEach(season => {
        season.valid_thru = this.parseDate(season.valid_thru_vuetifyDate);
        if (season._id) {
          this.updateSeason(season);
        } else {
          this.createSeason(season);
        }
      });
    },
    addSeason() {
      this.seasons.push({});
    },
    parseDate(date) {
      if (!date) return null;
      return new Date(date).toISOString();
    }
  }
};
